import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import { FaCut } from 'react-icons/fa';
import { BiInfoCircle } from 'react-icons/bi';
import Modal from 'app/modal/v2/index';

// "Start a new story from here?" — the confirmation step before "Split Story
// from here" moves the member's selection into a brand-new story. Confirming
// creates that story immediately (see ./index.js) — there's no separate Story
// Settings step anymore, so this stays open with a disabled button while that
// happens, and surfaces an error inline if it fails.
const ConfirmSplitStory = ({ onConfirm, onClose, isSubmitting, error }) => (
  <Modal onClose={onClose} closeButton bg="white" maxWidth={420} p="28px 24px 24px">
    <Heading fontFamily="Bitter" fontWeight={400} fontSize="30px" color="#000000" mb={3} pr={4}>
      Start a new story from here?
    </Heading>
    <Text fontFamily="Poppins" fontSize="18px" lineHeight="200%" color="#64748B" mb={3}>
      This item and everything after it will move into a new story.
    </Text>
    <Flex
      alignItems="center"
      sx={{ gap: '10px' }}
      bg="#FFF7E6"
      p="14px 16px"
      mb={4}
      css="border-radius: 10px;"
    >
      <Text as={BiInfoCircle} color="#8A6D3A" size={22} css="flex-shrink: 0;" />
      <Text fontFamily="Poppins" fontWeight={600} fontSize="16px" color="#0E0E0E" lineHeight="20px" >
        This can't be undone.
      </Text>
    </Flex>
    {!!error && (
      <Text fontFamily="Poppins" fontSize="14px" color="red" mb={3}>
        {error?.response?.data?.errors?.[0]?.detail ||
          error?.message ||
          "We couldn't do that. Please try again."}
      </Text>
    )}
    <Box>
      <Button
        type="button"
        variant="primary"
        width="100%"
        height={48}
        fontFamily="Poppins"
        fontWeight={500}
        fontSize="16px"
        lineHeight="20px"
        color="#FFFFFF"
        mb={2}
        disabled={isSubmitting}
        className={isSubmitting && "loading"}
        onClick={onConfirm}
        css="border-radius: 23px; display: flex; align-items: center; justify-content: center; gap: 8px;"
      >
        <FaCut size={18} />
        {isSubmitting ? 'Splitting story' : 'Split story'}
      </Button>
      <Button
        type="button"
        variant="outline"
        width="100%"
        height={48}
        fontFamily="Poppins"
        fontWeight={600}
        fontSize="16px"
        color="#64748B"
        disabled={isSubmitting}
        onClick={onClose}
        css="border-radius: 23px;
border: 1.5px solid #64748B;"
      >
        Cancel
      </Button>
    </Box>
  </Modal>
);

ConfirmSplitStory.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.object,
};

ConfirmSplitStory.defaultProps = {
  isSubmitting: false,
  error: null,
};

export default ConfirmSplitStory;
